import React from "react";
import { Tooltip } from "antd";
import { getIconUrl } from "../../services/asset";
import styles from "./SearchSubmitButton.scss";
import { Button } from "../Button/Button";

const SearchSubmitButton = ({ onSubmit, onReset, className }) => (
  <div className={onReset ? styles.wrapper : `${styles.wrapper} ${styles.wrapperNoReset}`}>
    {onReset && (
      <Tooltip title="Resetiraj filtere">
        <span className={styles.resetBtn} onClick={onReset}>
          <img alt="Resetiraj" src={getIconUrl("reload.svg")} />
        </span>
      </Tooltip>
    )}
    <Button
      type="primary"
      size="large"
      onClick={onSubmit}
      className={`${styles.submit} ${className}`}
    >
      Traži
    </Button>
  </div>
);

SearchSubmitButton.defaultProps = {
  className: "",
  onReset: null
};

export default SearchSubmitButton;



// WEBPACK FOOTER //
// ./src/components/SearchSubmitButton/index.tsx